import { ExtranetActivatableProductPreviewDto } from '@pharmac-extranet/extranet-api'
import { ExtranetContainer, formatDateString, useLanguage } from '@pharmac-extranet/shared'
import { PharmacInput, PharmacLabel, PharmacLoadingDots, PharmacText } from '@pharmac/ui'
import { useCustomerContext } from '../../../features/customer/CustomerProvider'
import { ShopActivateProductPreviewItem } from './ShopActivateProductPreview'

type Props = {
  codeInput: string
  setCodeInput: (v: any) => void
  previewProduct: ExtranetActivatableProductPreviewDto | undefined
  previewIsLoading: boolean
  previewError: boolean
  hasRoles: boolean
  alreadyUsedError: boolean | undefined
  alreadyActivatedError: boolean | undefined
  notActiveError: boolean | undefined
  activatedError: boolean | undefined
}

export const ShopActivateCodeModalContent = ({
  codeInput,
  previewProduct,
  previewError,
  previewIsLoading,
  setCodeInput,
  hasRoles,
  alreadyActivatedError,
  alreadyUsedError,
  notActiveError,
  activatedError,
}: Props) => {
  const { t, i18n } = useLanguage()
  const { customer } = useCustomerContext()

  return (
    <ExtranetContainer
      full
      flexColumn
      paddingSmall
    >
      <ExtranetContainer
        full
        flexColumn
      >
        <PharmacLabel marginSmallBottom>
          {t('extranet:shop.activateCodeModal.addCode')}
        </PharmacLabel>
        <div style={{ width: '100%' }}>
          <PharmacInput
            onChange={(v) => setCodeInput(v)}
            value={codeInput}
          />
        </div>
      </ExtranetContainer>

      {codeInput.length > 35 &&
        previewProduct &&
        !alreadyUsedError &&
        !alreadyActivatedError &&
        !notActiveError && (
          <>
            <ExtranetContainer
              full
              flexColumn
              marginLargeTop
              paddingLargeTop
              style={{ borderTop: '2px dashed var(--color-accent-4)' }}
            >
              <ExtranetContainer
                flexRow
                full
                alignCenter
              >
                <ExtranetContainer paddingSmallRight>
                  <PharmacLabel>{t('extranet:shop.activateCodeModal.customer')}:</PharmacLabel>
                </ExtranetContainer>
                <PharmacText>{customer?.officialName}</PharmacText>
              </ExtranetContainer>

              <ExtranetContainer
                full
                style={{
                  backgroundColor: 'var(--color-white)',
                  borderRadius: '22px',
                  border: '2px solid var(--color-accent-4)',
                }}
                flexColumn
                paddingMediumHorizontal
                paddingMediumTop
                marginLargeVertical
              >
                <>
                  <ShopActivateProductPreviewItem
                    key={1}
                    product={previewProduct}
                  />
                  <ExtranetContainer
                    flexRow
                    full
                    alignCenter
                    paddingLargeVertical
                  >
                    <ExtranetContainer>
                      <PharmacLabel>{t('extranet:shop.product.viewable')}:</PharmacLabel>
                    </ExtranetContainer>
                    {!previewProduct.accessPeriod?.isUnlimited ? (
                      <ExtranetContainer
                        alignCenter
                        paddingSmallLeft
                      >
                        {`${i18n.language !== 'fi' ? t('extranet:shop.product.till') : ''} ${previewProduct.subscriptionEndDate ? formatDateString(previewProduct.subscriptionEndDate) : '-'} ${i18n.language === 'fi' ? t('extranet:shop.product.till') : ''}`}
                      </ExtranetContainer>
                    ) : (
                      <ExtranetContainer
                        alignCenter
                        paddingSmallLeft
                      >
                        {t('extranet:shop.product.unlimitedAccess')}
                      </ExtranetContainer>
                    )}
                  </ExtranetContainer>

                  {!hasRoles && (
                    <ExtranetContainer paddingLargeBottom>
                      <PharmacText style={{ color: 'var(--color-danger)' }}>
                        {t('extranet:shop.activateCodeModal.roleError')}
                      </PharmacText>
                    </ExtranetContainer>
                  )}
                </>
              </ExtranetContainer>
            </ExtranetContainer>
          </>
        )}
      {codeInput.length > 35 && previewIsLoading && <PharmacLoadingDots />}
      {codeInput.length > 35 && previewError && (
        <PharmacText
          paddingSmallTop
          style={{ color: 'var(--color-danger)' }}
        >
          {t('extranet:shop.activateCodeModal.codeError')}
        </PharmacText>
      )}
      {codeInput.length > 35 && alreadyUsedError && (
        <PharmacText
          paddingSmallTop
          style={{ color: 'var(--color-danger)' }}
        >
          {t('extranet:shop.activateCodeModal.usedError')}
        </PharmacText>
      )}
      {codeInput.length > 35 && notActiveError && (
        <PharmacText
          paddingSmallTop
          style={{ color: 'var(--color-danger)' }}
        >
          {t('extranet:shop.activateCodeModal.expiredError')}
        </PharmacText>
      )}
      {codeInput.length > 35 && activatedError && (
        <PharmacText
          paddingSmallTop
          style={{ color: 'var(--color-danger)' }}
        >
          {t('extranet:shop.activateCodeModal.activatedError')}
        </PharmacText>
      )}
    </ExtranetContainer>
  )
}
